
import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { lastValueFrom, Subject, takeUntil } from "rxjs";
import { LoteService } from "src/app/core/services/lote.service";

// Tipo solo de ejemplo
interface ResumenAvanceFirma {
  cantidad_total: number;
  cantidad_firmada: number;
  // ...
}

@Component({
    selector: 'app-firmantes-component',
    templateUrl: './firmantes.component.html',
    styleUrls: ['./firmantes.component.scss']
})
export class FirmantesComponent implements OnInit {


    private destroy$ = new Subject<void>();
    modalResumenIsOpen:boolean = false;
    resumenAvanceFirma:any;
    lote:any;

    usuariosFirma:any[] = [];   

    formSearch: FormGroup;

    resumeItemSelected:any;
    
    constructor(
        private route: ActivatedRoute,    
        private loteService: LoteService , 
        private fb: FormBuilder    
    ){

      this.formSearch = this.fb.group({
        usuario:  new FormControl('' , []) 
      })

    }


    ngOnInit(): void {
        this.route.paramMap
        .pipe(takeUntil(this.destroy$)) // Desuscribe automáticamente al destruir el componente
        .subscribe(async params => {
            // 'id' es el nombre del parámetro definido en tu configuración de rutas
            // Por ejemplo: path: 'firmas/firma/:id'
            const id = params.get('id');
            if (Number(id)) {                
                this.lote =  await this.showLote(Number(id));
                let stats = await  lastValueFrom(this.loteService.getResumenFirma( Number(id)  , null ));                                
                if ( stats?.body){                          
                    this.resumenAvanceFirma = stats.body;                                       
                }    
            } 
        });        
    }


    
  getProgress(resumen: ResumenAvanceFirma): number {
    if (!resumen.cantidad_total || resumen.cantidad_total === 0) {
      return 0;
    }

    return (resumen.cantidad_firmada / resumen.cantidad_total) * 100;
  }
  
  async showLote(id: number) {
    const lote = await lastValueFrom(this.loteService.show(id));
    return lote;
  }

  async selectResumeItem( resumeItem: any){

    if( resumeItem.es_grupo ){
      this.resumeItemSelected = resumeItem;
      this.getUsers();
    }else {
      this.resumeItemSelected = null;
    }
    
  }

  async getUsers(){
    if( this.resumeItemSelected?.ids_lote_certificado  ){
      let list = this.resumeItemSelected?.ids_lote_certificado;

      let usuario = this.formSearch.value.usuario;


      let result =    await  lastValueFrom(this.loteService.getUsuariosLote(  this.lote.id  , list ,  {usuario} ));       

      let users = result.body.map((x: any) => {
        return {
          ...(x?.loteCertificado?.certificado?.usuario || {}),
          ...(x?.loteCertificado.certificado || {}),
          firmado:((x?.url && x?.url_base) ?  true :  false),

        };
      });

      this.usuariosFirma=  users;
    }
  }
}